import React, { FC, useCallback, useState } from "react";
import Box from "../../../../shared/ui/display/Box";
import Paper from "../../../../shared/ui/display/Paper";
import useDefaultErrorWrapper from "../../../../shared/hooks/useDefaultErrorWrapper";
import useFirebaseAppFunction from "../../../../shared/hooks/useFirebaseAppFunction";
import AuthSelectPhoneForm from "../AuthSelectPhoneForm";

export type AuthSelectPhoneFormContainerProps = {
  email: string;
  primaryPhoneNumber: string;
  additionalPhoneNumber: string;
  onPhoneSelected: (params: {
    phoneNumber: string;
    phoneType: "primary" | "additional";
  }) => void;
};

const AuthSelectPhoneFormContainer: FC<AuthSelectPhoneFormContainerProps> = ({
  email,
  primaryPhoneNumber,
  additionalPhoneNumber,
  onPhoneSelected,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const { runAsyncFunction } = useDefaultErrorWrapper();

  const sendCustomerPortalAuthCode = useFirebaseAppFunction(
    "sendCustomerPortalAuthCode",
  );

  const handleSelect = useCallback(
    async (phoneType: "primary" | "additional") => {
      try {
        setIsLoading(true);
        const { data } = await runAsyncFunction(sendCustomerPortalAuthCode, {
          email,
          phoneType,
        });

        if (data.status === "error") return;

        onPhoneSelected({ phoneNumber: data.data.phoneNumber, phoneType });
      } finally {
        setIsLoading(false);
      }
    },
    [email, onPhoneSelected, runAsyncFunction, sendCustomerPortalAuthCode],
  );

  return (
    <Paper>
      <Box p={6}>
        <AuthSelectPhoneForm
          primaryPhoneNumber={primaryPhoneNumber}
          additionalPhoneNumber={additionalPhoneNumber}
          onSelect={handleSelect}
          isLoading={isLoading}
        />
      </Box>
    </Paper>
  );
};

export default AuthSelectPhoneFormContainer;
